import MasterPage, { nameColumn, UsageCount } from "./MasterPage";
import { DeviceType } from "../../types";
import { formatDate } from "../../utils/format";

export default function DeviceTypesPage() {
    return (
        <MasterPage<DeviceType>
            title="Device Types"
            subtitle="Platforms software is installed on (Windows, Android, iOS…)."
            endpoint="/device-type"
            singular="device type"
            emptyForm={{ name: "" }}
            toForm={(r) => ({ name: r.name })}
            usage={(r) => r._count?.customerProducts ?? 0}
            fields={[{ name: "name", label: "Name", kind: "text", required: true, placeholder: "e.g. Android" }]}
            columns={[
                nameColumn<DeviceType>(),
                { key: "usage", header: "In use", render: (r) => <UsageCount count={r._count?.customerProducts} /> },
                { key: "created", header: "Created", hideOnMobile: true, render: (r) => <span className="text-slate-500">{formatDate(r.createdAt)}</span> },
            ]}
        />
    );
}